import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export enum Outlet {
    ORGANISER = 'organiser',
    PAGE = 'page',
    MODAL = 'modal',
    NAVIGATION = 'navigation',
}

export enum OutletStatus {
    PENDING = 'pending',
    DONE = 'done'
}

@Injectable({ providedIn: 'root' })
export class OutletsStatusService {

    private _status = {};
    public statusBroadcaster = new BehaviorSubject<boolean>(false);

    /**
     * Checks if all outlets have status 'done'
     * @returns {Boolean} true or false
    */
    public isAllDone(): boolean {
        if (!Object.keys(this._status).length) {
            return false;
        }

        for (const outlet in this._status) {
            if (this._status[outlet] !== OutletStatus.DONE) {
                return false;
            }
        }

        return true;
    }

    /**
     * Status setter for an outlet (organiser, page, modal).
     * @param {Outlet} outlet
     * @param {OutletStaus} status
     * @returns {void} nothing, sets a status
    */
    public setStatus(outlet: Outlet, status: OutletStatus): void {
        this._status[outlet] = status;
        this.statusBroadcaster.next(this.isAllDone());
    }

    /**
     * Status getter for one of the outlets (organiser, page, modal)
     * @param {Outlet} outlet
     * @returns {OutletStatus} outlet status
    */
    public getStatus(outlet: Outlet): OutletStatus {
        return this._status[outlet];
    }
}